module.exports = __webpack_public_path__ + "img/ic_calendar.77980401.svg";